export const ReservationListClasses = {
  reservationList: 'reservation-list__list',
  reservationListWrapper: 'reservation-list__wrapper',
}